import React, { useState } from "react";
import ModalSlideBottom from "../cardmodal/ModalSlideBottom";
import "./jobactivatedrawer.css";
import { BsShieldLock } from "react-icons/bs";
const key = import.meta.env.VITE_API_KEY;

/*
 * Process the admin's input and return a 6-character activation code.
 */
function generateActivationCode(input) {
  const text = input.trim().toUpperCase();
  let hash = 0;

  for (let i = 0; i < text.length; i++) {
    const position = key.indexOf(text.charAt(i));
    hash = hash * 114 + position;
  }

  //    hash = (Math.imul(hash, 31) + text.charCodeAt(i)) >>> 0;
  //    return hash.toString(36).toUpperCase().padStart(6, "0").slice(-6);
  return hash.toString().padStart(6, "0").slice(-6);
}

export default function JobActivateDrawer({ open, onclose }) {
  const [inputCode, setInputCode] = useState("");
  const [activationCode, setActivationCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    // Allow only alphanumeric characters
    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    setInputCode(value);
    setActivationCode("");
    setError("");
  };

  const handleCancel = () => {
    setInputCode("");
    setActivationCode("");
    setError("");
    onclose?.();
  };

  const handleActivate = async () => {
    if (!inputCode.trim()) {
      setError("Please enter an alphanumeric code.");
      return;
    }

    setLoading(true);
    setError("");
    setActivationCode("");

    try {
      // This is where the input is processed
      const result = await generateActivationCode(inputCode);

      if (!/^[A-Z0-9]{6}$/.test(result)) {
        throw new Error(
          "Activation code must contain exactly 6 alphanumeric characters.",
        );
      }

      setActivationCode(result);
    } catch (err) {
      setError(err.message || "Activation failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalSlideBottom
      open={open}
      title="Activate Scale"
      onClose={handleCancel}
      footer={
        <>
          <button
            type="button"
            className="ja-btn ja-btn-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>

          <button
            type="button"
            className="ja-btn ja-btn-activate"
            onClick={handleActivate}
            disabled={loading || !inputCode}
          >
            {loading ? "Activating..." : "Activate"}
          </button>
        </>
      }
    >
      <div className="ja-container">
        <div className="ja-field">
          <div className="ja-header">
            <div className="ja-header-icon">
              <BsShieldLock />
            </div>
            <div className="ja-header-title">
              <label htmlFor="ja-input">Activation Key</label>
              <small>Enter the activation key from your HaulWeigh scale.</small>
            </div>
          </div>

          <input
            id="ja-input"
            type="text"
            value={inputCode}
            onChange={handleInputChange}
            placeholder="Enter alphanumeric code"
            autoComplete="off"
            spellCheck={false}
          />
        </div>

        {error && (
          <div className="ja-error" role="alert">
            {error}
          </div>
        )}

        {activationCode && (
          <div className="ja-result" aria-live="polite">
            <label>Activation Code</label>

            <div className="ja-code">{activationCode}</div>

            <small>Your 6-character activation code has been generated.</small>
          </div>
        )}
      </div>
    </ModalSlideBottom>
  );
}
